import React from "react";
import {
  HashRouter as Router,
  Switch,
  Route
} from "react-router-dom";

import NotFound from '../pages/NotFound';
import Checkout from "../pages/action/checkout";
import CartController from "../controllers/CartController";


const Routes = () => {
  return (
    <Router>
        <Switch>
          <Route exact path="/" render={(props) => (<CartController {...props} mode="schedule" />)}/>
          <Route path="/cart" render={(props) => (<CartController {...props} mode="cart" />)} />
          <Route path="/subscriptions" render={(props) => (<CartController {...props} mode="subscriptions" />)} />
          <Route path="/passes" render={(props) => (<CartController {...props} mode="passes" />)} />
          <Route path="/checkout" render={(props) => (<CartController {...props} mode="checkout" />)} />
          <Route path="*" component={NotFound} />
        </Switch>
    </Router>
  );
}

export default Routes;